<template>
  <div class="modal fade" id="payBillsModal" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body p-4">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            id="pay-bill-close"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2 text-success">
              {{ $t("bills.pay_bill") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />

          <form
            id="upgradePlanForm"
            class="row g-4 mt-2"
            onsubmit="return false"
          >
            <div class="col-12">
              <label class="form-label" for="operationTime">{{
                $t("bills.slug")
              }}</label>
              <input
                type="text"
                disabled
                v-model="selectedBill.slug"
                class="form-control"
              />
            </div>
            <div class="col-12">
              <label class="form-label" for="price">{{
                $t("bills.remaining")
              }}</label>
              <div class="input-group">
                <input
                  type="number"
                  :value="selectedBill.price - selectedBill.paid"
                  disabled
                  class="form-control"
                />
                <div class="input-group-text">{{ settings.currency }}</div>
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="paid">{{
                $t("bills.paid")
              }}</label>
              <div class="input-group">
                <input
                  type="number"
                  v-model="paid_amount"
                  @input="validate"
                  class="form-control"
                />
                <div class="input-group-text">{{ settings.currency }}</div>
              </div>
            </div>
            <div class="col-12 text-center mt-12">
              <button
                class="btn btn-success me-2"
                type="button"
                :disabled="!validated || loading"
                @click="payBill(selectedBill)"
              >
                <i class="ti ti-circle-plus me-1"></i>
                {{ $t("bills.pay") }}
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ $t("control.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "BillsPay",
  computed: {
    ...mapGetters(["settings"]),
  },
  props: {
    selectedBill: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paid_amount: 0,
      validated: false,
      loading: false,
    };
  },
  methods: {
    async payBill(bill) {
      this.loading = true;
      const message = this.$t("bills.bill_paid");
      try {
        const response = await axios.post(`bills/${bill.id}/pay`, {
          paid_amount: this.paid_amount,
        });
        if (response.status == 200) {
          this.loading = false;
          this.$notify({
            text: message,
            type: "success",
          });
          this.$emit("updated");
        }
      } catch (error) {
        this.$notify({
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          type: "error",
        });
        this.loading = false;
      }
      this.$emit("updated");
      document.getElementById("pay-bill-close").click();
    },
    validate() {
      this.validated = true;
      if (
        this.paid_amount > this.selectedBill.price + this.selectedBill.paid ||
        this.paid_amount <= 0
      ) {
        this.validated = false;
      }
    },
  },
};
</script>
